import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addActionLive, editActionLive } from '../../../../../actions/liveDataActions';
import { updateActionLive } from '../../../../../actions/matchDataActions';
import moment from 'moment';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { addAction } from '../../../../../services/live';
import queryString from 'query-string';
import { editAction } from '../../../../../services/action';
import { List, Checkbox, DatePicker, Picker } from 'antd-mobile';
import ActionFormLayout from '../../../../../components/layouts/actions/ActionFormLayouts';
import './DebutForm.css';

const DebutForm = props => {
    const qs = props.history.location.search;
    const [option, setOption] = useState(getQueryStrigAction(qs).option);
    const [formValid, setFormValid] = useState(false);
    const [value, setValue] = useState(getQueryStrigAction(qs).time);
    const [mitemps, setMitemps] = useState(getQueryStrigAction(qs).halftime);
    const access = props.connexionReducer;
    const [isOnSubmit, setIsOnSubmit] = useState(false);

    useEffect(() => {
        setFormValid(value !== null && value !== '' && _.includes(['custom', 'now'], option) && mitemps);
    }, [option, value, mitemps])

    const actionEdited = queryString.parse(qs).action_edit ? JSON.parse(queryString.parse(qs).action_edit) : {};
    const actionType = !_.isEmpty(actionEdited) ? {'@id': actionEdited.type, name: _.upperFirst(actionEdited.data.label)} : (queryString.parse(qs).action_type ? JSON.parse(queryString.parse(props.history.location.search).action_type) : {});
    const min = !_.isEmpty(actionEdited) ? actionEdited.minute : (queryString.parse(qs).settings ? JSON.parse(queryString.parse(qs).settings).minute : 0);

    return (
        <ActionFormLayout title={actionType.name === 'Prolongations' ? 'Début de la prolongation' : 'début du match'} 
            submit={() => submit(props, {option: option,hour: value, halftime: mitemps}, access, getQueryStrigAction(qs).action, setFormValid, setIsOnSubmit, actionType, min)}
            enabled={formValid}
            showBtn={true}
            isOnSubmit={isOnSubmit}
        >
            <div className='ls_debut_form'>
                <List>
                    <List renderHeader={() => <Title text={actionType.name === 'Prolongations' ? 'Les prolongations commencent:' : 'le match commence :'} />}>
                        <List.Item onClick={() => setOption('now')} multipleLine>
                            <Checkbox
                                defaultChecked={option === 'now'}
                                checked={option === 'now'}
                                onChange={() => setOption('now')}
                            >
                                <span style={{marginLeft: '10px'}} className='common'>{actionType.name === 'Prolongations' ? 'maintenant' : 'à l\'heure'}</span>
                            </Checkbox>
                        </List.Item>
                        <List.Item onClick={() => setOption('custom')} multipleLine>
                            <Checkbox
                                defaultChecked={option === 'custom'}
                                checked={option === 'custom'}
                                onChange={() => setOption('custom')}
                            >
                                <span style={{marginLeft: '10px'}} className='common'>à un horaire décalé</span>
                            </Checkbox>
                        </List.Item>
                    </List>
                    {
                        option === 'custom' && 
                        <List renderHeader={() => <Title text={actionType.name === 'Prolongations' ? 'Heure de début des prolong' : 'Heure de début du match'} />}>
                            <DatePicker
                                mode="time"
                                value={moment(value, 'H:mm').toDate()}
                                locale={{DatePickerLocale: {year: 'Année', month: 'Mois', day: 'Jour', hour: '', minute: ''}, okText: 'OK', dismissText: 'Annuler'}}
                                onOk={val => setValue(moment(val).format('H:mm'))}
                                className='ls_date_picker'
                                disabled={option !== 'custom'}
                            >
                                <List.Item>
                                    <span style={{marginLeft: '10px', color: '#bdc4cc', fontSize: '14px'}}>{actionType.name === 'Prolongations' ? 'Heure de début des prolong' : 'Heure de début du match'}</span>
                                </List.Item>
                            </DatePicker>
                        </List>
                    }
                    {
                        value && _.includes(['custom','now'], option) && actionType.name !== 'Prolongations' &&
                        <List renderHeader={() => <Title text={'caractéristiques du match'} />}>
                            <Picker
                                data={caracteristique}
                                value={_.values(_.pick(_.filter(caracteristique, c => c.value === parseInt(mitemps))[0],'value'))}
                                cols={1}
                                okText='OK'
                                dismissText='Annuler'
                                onOk={v => setMitemps(v[0])}
                                disabled={!(value && _.includes(['custom','now'], option))}
                            >
                                <List.Item>
                                    <span style={{marginLeft: '10px', color: '#bdc4cc', fontSize: '14px'}}>Durée des mi-temps</span>
                                </List.Item>
                            </Picker>
                        </List>
                    }
                </List>
            </div>
        </ActionFormLayout>
    )
}

const Title = props => <div className='common' style={{fontWeight: '700', textTransform: 'uppercase'}}>{props.text}</div>

const caracteristique = [
    {value: 20, label: '20min'}, 
    {value: 25, label: '25min'}, 
    {value: 30, label: '30min'}, 
    {value: 35, label: '35min'}, 
    {value: 40, label: '40min'}, 
    {value: 45, label: '45min'}
]

const getQueryStrigAction = qs => {
    if(queryString.parse(qs).action_edit) {
        const action = JSON.parse(queryString.parse(qs).action_edit);
        return {
            action: action['@id'],
            option: action.data.option,
            time: action.data.hour,
            halftime: action.data.halftime
        };
    }

    const settings = JSON.parse(queryString.parse(qs).settings);
    return {action: '', option: '', time: moment(settings.debutAt, 'YYYYMMDDHm').format('H:mm'), halftime: '45'}
}

const submit = (props, data, access, action, setFormValid, setIsOnSubmit, actionType, minute) => {
    setFormValid(false);
    setIsOnSubmit(true);
    const {id} = props.match.params;
    const dataAction = {
        option: data.option,
        actionName: `${actionType.name === 'Prolongations' ? 'Début de la prolongation' : 'Début de la rencontre'} (${data.hour})`,
        label: actionType.name === 'Prolongations' ? _.toLower(actionType.name) : 'debut',
        hour: data.hour,
        startAt: moment().format('H:mm:ss'),
        halftime: actionType.name === 'Prolongations' ? 15 : data.halftime
    }
    if(action !== '') {
        editAction(action, {
            data: dataAction,
            ontime: data.option === 'now',
            hour: moment(data.hour, 'H:mm').unix(),
            minute,
            teamName: null
        }, access, id).then((response) => {
            setIsOnSubmit(false)
            props.editActionLive(id, response.data);
            props.history.push(`/live/${id}`)
        });
    }
    else {
        addAction(id, {
            type: actionType['@id'],
            teamId: null,
            ontime: data.option === 'now',
            hour: moment(data.hour, 'H:mm').unix(),
            minute,
            teamName: null,
            data: dataAction
        }, access).then((response) => {
            window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer début'
                }
            }), '*');
            setIsOnSubmit(false)
            props.addActionLive(id, response.data);
            props.updateActionLive(id, response.data.actions);
            props.history.push(`/live/${id}`);
        })
    }
}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({addActionLive, editActionLive, updateActionLive}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DebutForm));